export const _LC_CONTEXT_VARIABLES_KEY = Symbol.for("lc:context_variables");
